import { Badge } from "@/components/ui/badge"
import type { CollabSuggestionStatusEnum } from "@/types/contents"

const STATUS_COLORS: Record<
  CollabSuggestionStatusEnum,
  "gray" | "success" | "error"
> = {
  pending: "gray",
  accepted: "success",
  rejected: "error",
}

export function SuggestionStatusBadge({
  status,
}: {
  status: CollabSuggestionStatusEnum
}) {
  return (
    <Badge
      color={STATUS_COLORS[status]}
      size="sm"
      type="pill-color"
      className="capitalize"
    >
      {status}
    </Badge>
  )
}
